import * as React from "react";
import { classes, stylesheet } from "typestyle";
import { Gray20, typeCompact14Medium } from "@traceair/tds";
import ExpandLessIcon from "./ExpandLessIcon";
import ExpandMoreIcon from "./ExpandMoreIcon";

const css = stylesheet({
  container: {
    borderTop: `1px solid ${Gray20}`,
    borderBottom: `1px solid ${Gray20}`,
  },
  header: {
    padding: "5px 12px",
    minHeight: "40px",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  headerIcon: {
    width: 24,
    height: 24,
  },
  iconButton: {
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  commentContent: {
    whiteSpace: "pre-wrap",
    padding: "8px 20px",
  },
});

interface IProps {
  comment: string;
}

export const CommentForPilot: React.FC<IProps> = ({ comment }) => {
  const [open, isOpen] = React.useState(true);
  return (
    <div className={css.container}>
      <div className={css.header} onClick={() => isOpen((s) => !s)}>
        <div className={classes(css.headerIcon, css.iconButton)}>
          {open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </div>
        <div className={typeCompact14Medium}>Comment</div>
        <div className={css.headerIcon} />
      </div>
      <div
        className={classes(css.commentContent, typeCompact14Medium)}
        style={{ display: open ? "block" : "none" }}
      >
        {comment}
      </div>
    </div>
  );
};
